/**
 * 0zzz-tzu Q1 (CEO 2026-10-11): the browser remembers the registration token of its last Didit start, so a restart can
 * send it as proof of "same person" (the server then replaces the earlier name hold instead of answering 409).
 *
 * sessionStorage on purpose: it survives the redirect to Didit and back in the same tab and is gone when the tab closes.
 * A missing token is not an error: the server treats the caller as another person (the 409 the form already shows).
 * Every access is guarded (private windows and blocked storage throw); registration must work without it.
 */
export const PENDING_REGISTRATION_TOKEN_KEY = 'pendingRegistrationToken';

export function getPendingRegistrationToken(): string | undefined {
  try {
    return sessionStorage.getItem(PENDING_REGISTRATION_TOKEN_KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function setPendingRegistrationToken(token: string): void {
  try {
    sessionStorage.setItem(PENDING_REGISTRATION_TOKEN_KEY, token);
  } catch {
    // Storage blocked: the restart just carries no proof.
  }
}

export function clearPendingRegistrationToken(): void {
  try {
    sessionStorage.removeItem(PENDING_REGISTRATION_TOKEN_KEY);
  } catch {
    // Nothing to clear.
  }
}
